import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox } from '@americanexpress/dls-react';
import { setNonStopAction } from '../../../ducks/filtersDuck';
import { getIsNonStop } from '../../../selectors/filtersSelectors';

const NonStopCheckbox = () => {
  const { formatMessage } = useIntl();
  const isNonStop = useSelector(getIsNonStop);
  const dispatch = useDispatch();
  const onNonStopChange = (event) => {
    dispatch(setNonStopAction(event.target.checked));
  };
  return (
    <Checkbox
      id="nonStopCheckbox"
      label={formatMessage({ id: 'non_stop_flights_only' })}
      onChange={onNonStopChange}
      checked={isNonStop}
      value={isNonStop}
    />
  );
};

export default NonStopCheckbox;
